const WORDS = ["ROAS", "CPA", "CAC", "LTV", "CPL", "MER", "CTR", "CVR", "AOV", "TOFU", "MOFU", "BOFU", "ABO", "CBO", "CAPI", "GA4", "RTO"];

export const Marquee = () => (
  <div className="marquee" data-testid="metrics-marquee" aria-hidden>
    <div className="marquee-track">
      {[0, 1].map((k) => (
        <span key={k} className="marquee-group">
          {WORDS.map((w, i) => (
            <span key={w + k} className="marquee-item">
              <span className={i % 3 === 0 ? "text-[#E4572E]" : i % 3 === 1 ? "text-[#1F2A44]" : "text-[#2B59C3]"}>{w}</span>
              <span className="marquee-star">✶</span>
            </span>
          ))}
        </span>
      ))}
    </div>
  </div>
);
